import React from 'react';
import { Link } from 'react-router-dom';
import Carousel from './Carousel';

const Projects = () => {

    const items1 = [
        "https://i.ibb.co/fHF6ygy/Screenshot-11.png",
"https://i.ibb.co/YLNqr8s/Screenshot-12.png",
"https://i.ibb.co/k8781tB/super-trifle-b804a5-netlify-app-signup-i-Phone-XR.png",
"https://i.ibb.co/T0bkyzT/324476873-715414323520375-5025722734419404164-n.jpg",
"https://i.ibb.co/FzKftJ2/super-trifle-b804a5-netlify-app-i-Pad-Air.png",
"https://i.ibb.co/9NY9fSZ/super-trifle-b804a5-netlify-app-signup-i-Pad-Air-2.png"
    ]
    const items2 = [
        "https://i.ibb.co/6JRGCyr/the-techhub-netlify-app.png",
"https://i.ibb.co/njcFMN4/paralax-home-img-4.jpg",
"https://i.ibb.co/V9tTKPB/the-techhub-netlify-app-services.png",
"https://i.ibb.co/99kmrjn/the-techhub-netlify-app-services3.png"
    ]
    const items3 = [
        "https://i.ibb.co/YBhk7qF/easylearning-3c312-web-app-login-i-Pad-Air-1.png",
"https://i.ibb.co/6R5jt0P/easylearning-3c312-web-app-login-i-Pad-Air-2.png",
"https://i.ibb.co/QMcnhNr/easylearning-3c312-web-app-login-i-Pad-Air.png"
    ]
    const items4 = [
        "https://i.ibb.co/Wvm5RWz/doctorshouse-95f5f-web-app-i-Pad-Air-1.png",
    "https://i.ibb.co/gDXWXgK/doctorshouse-95f5f-web-app-i-Pad-Air-2.png",
    "https://i.ibb.co/ySh9t8J/doctorshouse-95f5f-web-app-i-Pad-Air-3.png",
    "https://i.ibb.co/1XsCR0r/doctorshouse-95f5f-web-app-i-Pad-Air.png"
    ]
    
    
    
    
    
    
    


    return (
        <div id="project" className='bg-[#f5f7ff]'>
            <h1 className='text-5xl text-center pt-8'
            data-aos="fade-down"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true">Projects</h1>
            <div className='flex flex-col justify-center items-center'
            data-aos="fade-right"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <div className="mx-10 my-20 w-4/5 md:w-3/5 h-[600px]  shadow-xl rounded-2xl">
                <div className="h-[350px] md:h-4/6">
                <Carousel items={items1} >
                </Carousel>
                </div>

                <div className="h-2/6 p-10  divide-y-2  divide-blue-200">
                    <div>
                    <h1 className="text-3xl font-bold">MoPo Market</h1>
                    <p>
                    <span className='font-bold'>Technology Used</span>: : React, Node Js, Express Js, Firebase, MongoDB, React Router and React Nesting Router, Private Route, React Hook Form
                    </p>
                    </div>
                    <div className="flex justify-center items-center gap-3 my-2 py-2">
                    <Link onClick={() => window.open( "https://mopo-online.netlify.app/")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>LIVE</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/mobile-point")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>CLIENT</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/mobile-point-server")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>SERVER</Link>
                    
                    </div>
                </div>
            </div>
            </div>

            <div className='flex flex-col justify-center items-center'
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <div className="mx-10 my-20 w-4/5 md:w-3/5 h-[600px]  shadow-xl rounded-2xl">
                <div className="h-[360px] md:h-4/6">
                <Carousel
                items={items2}
                ></Carousel>
                </div>

                <div className="h-2/5 p-10  divide-y-2  divide-blue-200">
                    <div>
                    <h1 className="text-3xl font-bold">The Tech Hub</h1>
                    <p>
                    <span className='font-bold'>Technology Used</span>: : React, Node Js, Express Js, Firebase, MongoDB, React Router and React Nesting Router, Private Route
                    </p>
                    </div>
                    <div className="flex justify-center items-center gap-3 my-2 py-2">
                    <Link onClick={() => window.open( "https://the-techhub.netlify.app/")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>LIVE</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/TheTechHub-client")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>CLIENT</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/theTechHub-server")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>SERVER</Link>
                    
                    </div>
                </div>
            </div>
            </div>
            <div className='flex flex-col justify-center items-center'
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <div className="mx-10 my-20 w-4/5 md:w-3/5 h-[600px]  shadow-xl rounded-2xl">
                <div className="h-[360px] md:h-4/6">
                <Carousel
                items={items3}
                ></Carousel>
                </div>

                <div className="h-2/5 p-10  divide-y-2  divide-blue-200">
                    <div>
                    <h1 className="text-3xl font-bold">Easy Learning</h1>
                    <p>
                    <span className='font-bold'>Technology Used</span>: : React, Node Js, Express Js, Firebase, MongoDB, React Router and React Nesting Router, Private Route
                    </p>
                    </div>
                    <div className="flex justify-center items-center gap-3 my-2 py-2">
                    <Link onClick={() => window.open( "https://easylearning-3c312.web.app/")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>LIVE</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/easy-learning")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>CLIENT</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/easy-learning-server")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>SERVER</Link>
                    
                    </div>
                </div>
            </div>
            </div>

            <div className='flex flex-col justify-center items-center'
            data-aos="fade-right"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <div className="mx-10 my-20 w-4/5 md:w-3/5 h-[600px]  shadow-xl rounded-2xl">
                <div className="h-[380px] md:h-4/6">
                <Carousel 
                items={items4}
                ></Carousel>
                </div>

                <div className="h-2/5 p-10  divide-y-2  divide-blue-200">
                    <div>
                    <h1 className="text-3xl font-bold">MentalHealth</h1>
                    <p>
                    <span className='font-bold'>Technology Used</span>: : React, Node Js, Express Js, Firebase, MongoDB, React Router, Private Route
                    </p>
                    </div>
                    <div className="flex justify-center items-center gap-3 my-2 py-2">
                    <Link onClick={() => window.open( "https://doctorshouse-95f5f.web.app/")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>LIVE</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/mental-care-client")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>CLIENT</Link>
                    <Link onClick={() => window.open( "https://github.com/arafatyamin/mental-care-server")}  target="_blank" className=' border-0 rounded-xl text-black bg-gray-300 py-1 md:py-3 px-4 md:px-12 shadow-2xl hover:link'>SERVER</Link>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default Projects;